import { pink, red } from '@material-ui/core/colors';

export const BeeAiStyles = (windowSize, isRTL, theme) => ({
  aiContainer: {
    maxWidth: 800,
    margin: '0 auto',
  },
  textArea: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  sectionTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
    fontSize: '1rem',
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#333'
  },
  submitButton: {
    backgroundColor: pink[500],
    color: 'white',
    '&:hover': {
      backgroundColor: pink[700],
    },
    borderRadius: 25,
    padding: '8px 20px',
    marginTop: theme.spacing(2),
    height: 40
  },
  checkboxLabel: {
    fontSize: '1rem',
  },
  checkboxDesc: {
    fontSize: 14,
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    lineHeight: 1.5,
  },
  optionBox: {
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f9f9f9',
    padding: theme.spacing(2),
    borderRadius: 4,
  },
  icon: {
    marginInlineEnd: 5,
    color: '#ff7777',
  },
  // New styles for file upload
  uploadButton: {
    margin: theme.spacing(1, 0),
    borderRadius: 4,
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f0f0f0',
    padding: theme.spacing(1, 2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: theme.palette.type === 'dark' ? `1px dashed ${theme.custom.border}` : '1px dashed #ccc',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#e5e5e5',
    },
  },
  uploadIcon: {
    marginInlineEnd: theme.spacing(1),
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#555',
  },
  filePreview: {
    // marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    backgroundColor: '#eee',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  removeIcon: {
    cursor: 'pointer',
    color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#777',
    '&:hover': {
      color: red[500],
    },
  },
  // New styles for color picker
  colorBox: {
    width: 30,
    height: 30,
    margin: theme.spacing(0.5),
    cursor: 'pointer',
    borderRadius: 4,
    display: 'inline-block',
    position: 'relative',
    border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #ddd',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  colorSelected: {
    border: '2px solid #333',
    '&::after': {
      content: '"✓"',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      color: '#fff',
      textShadow: '0px 0px 2px #000',
    },
  },
  colorPaletteButton: {
    margin: theme.spacing(1, 0),
    borderRadius: 4,
    backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#f0f0f0',
    padding: theme.spacing(1, 2),
    minHeight: '30px !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: theme.palette.type === 'dark' ? `1px dashed ${theme.custom.border}` : '1px dashed #ccc',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#e5e5e5',
    },
  },
  colorChip: {
    margin: theme.spacing(0.5),
    direction: 'ltr',
  },
  newFeatureSection: {
    marginBottom: theme.spacing(2),
  },
  newFeatureTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },
  historyContainer: {
    marginBottom: theme.spacing(3),
  },
  fullWidth: {
    width: '100%',
  },
  accordionSummary: {
    backgroundColor: (theme.palette.type === 'dark' ? theme.custom.surfaceElevated : theme.palette.grey[100]),
    color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000'
  },
  accordionSummaryGradient: {
    background: 'linear-gradient(90deg, rgb(255, 0, 110) 0%, rgb(255, 0, 64) 25.0%, rgb(255, 77, 42) 100%)',
    color: '#fff'
  },
  accordionTitle: {
    fontWeight: 500,
  },
  accordionDetails: {
    display: 'block',
    padding: theme.spacing(2),
  },
  radioGroup: {
    width: '100%',
  },
  historyItem: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: (theme.palette.type === 'dark' ? theme.custom.surface : theme.palette.background.paper),
    boxShadow: theme.shadows[1],
  },
  historyItemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  historyDate: {
    fontWeight: 500,
    color: (theme.palette.type === 'dark' ? theme.custom.textSecondary : theme.palette.text.secondary),
  },
  historyItemContent: {
    marginLeft: theme.spacing(3),
    paddingTop: theme.spacing(1),
    borderTop: `1px solid ${(theme.palette.type === 'dark' ? theme.custom.border : theme.palette.divider)}`,
  },
  historyMessage: {
    maxHeight: '100px',
    overflow: 'auto',
    whiteSpace: 'pre-wrap',
    fontSize: '0.875rem',
    color: (theme.palette.type === 'dark' ? theme.custom.textPrimary : theme.palette.text.primary),
  },
  revertButton: {
    minWidth: 150,
    direction: isRTL ? 'rtl' : 'ltr',
  },
})